<template>
  <div id="emptyrouteView">
    <router-view></router-view>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

let SELF;
export default {
  name: "empty-route-view"
};
</script>

<style scoped>
/*.*/
</style>
